module.exports = __webpack_public_path__ + "img/menu01.af67d86c.jpg";